"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Navbar_1 = require("./class/Navbar");
const VideoLightbox_1 = require("./class/VideoLightbox");
Navbar_1.Navbar.init();
VideoLightbox_1.VideoLightbox.init();
